//require main files for webpack
//require all sub folder of blocks
const blocksContext = require.context('./blocks', true, /block\.js$/);
const blockKeys = blocksContext.keys();

for (var i=0;i<blockKeys.length;i+=1) {
    const blockKey = blockKeys[i];
    blocksContext(blockKey);
}

// Require all icons in folder
function requireAll( r ) {
    r.keys().forEach( r );
}
requireAll( require.context( `../../../assets/icons/`, false, /\.svg$/ ) );
